import { useEffect, useState } from 'react';
import { Box, Card, CircularProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SortableList, TextButtonWithIcon } from '@/components';
import { Quiz, useProduct } from '@/core';
import { DialogHandleVariant, EditableVariant } from '@/features';

import { styles } from './styles.ts';

export const Variants = () => {
  const { t } = useTranslation();
  const [addVariantDialogOpen, setAddVariantDialogOpen] = useState(false);
  const handleAddVariantDialogOpen = () => setAddVariantDialogOpen(true);
  const {
    queries: { useProductQuizzes },
  } = useProduct();
  const { id } = useParams<{ id: string }>();
  const { data: quizResponse, isLoading, isError } = useProductQuizzes(Number(id));
  const [quizzes, setQuizzes] = useState<Quiz[]>([]);

  useEffect(() => {
    if (quizResponse?.data) {
      setQuizzes(quizResponse.data);
    }
  }, [quizResponse?.data]);

  if (isLoading) return <CircularProgress />;
  if (isError || quizResponse?.status !== 200)
    return <Box sx={{ fontStyle: 'italic' }}>{t('VARIANT.ERROR_WHILE_FETCHING')}</Box>;

  return (
    <Stack direction="column" mb={28}>
      <DialogHandleVariant open={addVariantDialogOpen} setOpen={setAddVariantDialogOpen} />
      <Typography variant="h2" gutterBottom mt={4}>
        {t('VARIANT.VARIANTS_TITLE')}
      </Typography>
      <Typography variant="body1">{t('VARIANT.DESCRIPTION')}</Typography>
      <Stack direction="column" mt={2}>
        {quizzes.length > 0 && (
          <Box sx={{ width: '100%' }}>
            <SortableList
              items={quizzes}
              onChange={setQuizzes}
              renderItem={(quiz) => (
                <SortableList.Item id={quiz.id}>
                  <SortableList.DragHandle />
                  <EditableVariant quiz={quiz} />
                </SortableList.Item>
              )}
            />
          </Box>
        )}

        <Card elevation={0} sx={[styles.card, quizzes.length > 0 ? { mt: 1 } : {}]}>
          <Typography variant="body1" gutterBottom color="text.secondary">
            {t('VARIANT.ADD_DESCRIPTION')}
          </Typography>
          <TextButtonWithIcon
            iconName={'add'}
            label={t('VARIANT.ADD')}
            onClick={handleAddVariantDialogOpen}
          />
        </Card>
      </Stack>
    </Stack>
  );
};
